// Main entry point for vinetta
import RootView from './components/root_view';

const Vinetta = RootView;
export default Vinetta;
